import { DataTable } from '../../../../design-system/data-table/data-table';
import { TransactionView } from '../../../../types/entity-types';
import { cn } from '../../../../utils/cn';
import { markAsPaidInvoiceTableColumnsDefinition } from './mark-as-paid-invoice-table-columns-definition';

// Random number large enough to minimize the number of pages and small enough to prevent performance issues
const PAGE_SIZE = 100;

type MarkAsPaidInvoiceTableProps = {
  transactions: TransactionView[];
  onToggleTransaction: (id: string) => void;
};

export const MarkAsPaidInvoiceTable = ({ transactions, onToggleTransaction }: MarkAsPaidInvoiceTableProps) => {
  return (
    <DataTable
      columns={markAsPaidInvoiceTableColumnsDefinition}
      data={transactions}
      pageSize={PAGE_SIZE}
      meta={{ onReviewInvoice: onToggleTransaction }}
      fullWidthSearchConfig={{
        show: true,
        placeholder: 'Search for transaction',
      }}
      scrollingAreaConfig={{
        show: true,
        classNameScrollingWrapper: cn('h-[155px]', {
          'h-[125px]': transactions.length === 1,
          'h-[190px]': transactions.length === 2,
          'h-[250px]': transactions.length === 3,
          'h-[325px]': transactions.length === 4,
          'h-[410px]': transactions.length === 5,
          'h-[458px]': transactions.length > 5,
          'h-[424px]': transactions.length >= PAGE_SIZE,
        }),
      }}
      noResultsMessage="No transactions found"
      className="pb-0"
    />
  );
};
